import * as Immutable from "immutable";
import keyConverter from "services/key-converter";

// Serialize response JSON from API so that it can be consumed by App.
// 1. Recursively convert keys to camelCase
// 2. Recursively convert to Immutable Lists and Maps

/**
 * @param {*} json
 * @returns {Immutable.Map|Immutable.List}
 */
export default function serialize(json) {
  return Immutable.fromJS(
    keyConverter(json)
  );
}
